import React, { FC } from 'react';

import { BadgeIllustration } from 'src/general/components/BadgeIllustration/BadgeIllustration';
import { BADGE } from 'src/general/components/BadgeIllustration/BadgeIllustration.type';

import { SetLocationPopupMicrocopyProps } from '../../SetLocationPopup.types';
import styles from './DeliveryOptions.module.scss';

export type DeliveryOptionsProps = {
  microcopy: SetLocationPopupMicrocopyProps;
  deliverable?: boolean;
};

export const DeliveryOptions: FC<DeliveryOptionsProps> = ({ microcopy, deliverable }) => {
  const {
    titleDeliveryAvailable,
    descriptionDeliveryAvailable,
    titleDeliveryNotAvailable,
    descriptionDeliveryNotAvailable,
  } = microcopy;

  return (
    <>
      {deliverable ? (
        <div className={styles.deliverableContainer}>
          <BadgeIllustration icon={BADGE.DELIVERY} background="none" shape="square" className={styles.deliveryImg} />
          <div className={styles.textContainer}>
            <span className={styles.title}>{titleDeliveryAvailable}</span>
            <div className={styles.descriptionWrapper}>
              <img src="/images/components/DeliveryOptions/Icon.svg" alt="" />
              <span className={styles.description}>{descriptionDeliveryAvailable}</span>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.undeliverableContainer}>
          <span className={styles.lineBreak} />
          <span className={styles.title}>{titleDeliveryNotAvailable}</span>
          <span className={styles.description}>{descriptionDeliveryNotAvailable}</span>
        </div>
      )}
    </>
  );
};
